import React from 'react';
import { ResourceAlias, ResourceAliasProps } from 'omni-package-react-core';
import { AccountResourceInfo } from '../AccountResource/AccountResource';

export interface AccountResourceProps<Data, Error = {}> extends Omit<ResourceAliasProps<Data, Error>, 'resourceSrc'> {
}

const AccountResourceAlias = <Data, Error = {}>({ ...props }: AccountResourceProps<Data, Error>) => (
  <ResourceAlias
    resourceSrc={AccountResourceInfo.name}
    {...props}
  />
);

export default AccountResourceAlias;
